import React from "react";

const InputSurveyInput = ({
  dimensionIndex,
  questionIndex,
  numberOfFields = 1,
  handleChange,
  defaultAnswer,
  inputType = "text",
  minNumber,
  maxNumber,
}) => {
  const numberProps =
    inputType === "number"
      ? {
          min: minNumber ?? 0,
          max: maxNumber,
        }
      : {};

  if (numberOfFields === 1) {
    return (
      <input
        id={`${dimensionIndex}_${questionIndex}_input`}
        className="form-control"
        onChange={handleChange}
        value={defaultAnswer ?? ""}
        type={inputType}
        {...numberProps}
      />
    );
  }

  return [...Array(numberOfFields)].map((_, inputIndex) => (
    <div
      key={`survey-question-field-input-${dimensionIndex}_${questionIndex}_${inputIndex}`}
      className={inputIndex < numberOfFields - 1 ? "pb-4" : ""}
    >
      <input
        id={`${dimensionIndex}_${questionIndex}_input_${inputIndex}`}
        name={inputIndex}
        className="form-control"
        onChange={handleChange}
        value={defaultAnswer?.[inputIndex] ?? ""}
        type={inputType}
        {...numberProps}
      />
    </div>
  ));
};

export default InputSurveyInput;
